import { Box, IconButton, Typography } from '@material-ui/core'
import { ArrowBack } from '@material-ui/icons'
import React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { routes } from '@/routes/config'

import { useStyles } from './styles'

interface LayoutProps {
  children: React.ReactNode
}

export function Layout({ children }: LayoutProps) {
  const classes = useStyles()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const isRedirect = searchParams.get('redirect')

  return (
    <Box className={classes.main}>
      <Box display='flex' alignItems='center'>
        <IconButton
          aria-label='Voltar'
          color='secondary'
          onClick={() =>
            isRedirect ? navigate(routes.Diagnoses()) : navigate(-1)
          }
        >
          <ArrowBack />
        </IconButton>
        <Typography variant='h1'>Conta Cromai</Typography>
      </Box>
      {children}
    </Box>
  )
}
